// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from '../../../store/store';

import { fetchEquipmentGroupById } from '../../../store/equipment/equipmentActions';

export async function equipmentGroupLoader({ params }) {
  const { equipmentGroupId } = params;

  if (!equipmentGroupId) {
    return null;
  }
  await store.dispatch(fetchEquipmentGroupById(equipmentGroupId));
  return null;
}

equipmentGroupLoader.hydrate = true;
